var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tenantType === 'ENERGY')?_c('EnergisaHome'):_vm._e(),(_vm.tenantType === 'FINANCE')?_c('GalapagosHome'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }